import BaseDataObject from './BaseDataObject';
import Money from './Money';
import ResultOdds from './ResultOdds';

export default class ResultInformation extends BaseDataObject {
  getTimestamp() {
    return this.getDate('timestamp');
  }

  setTimestamp(v) {
    return this.setDate('timestamp', v);
  }

  getResultType() {
    return this.getString('type');
  }

  setResultType(v) {
    return this.setString('type', v);
  }

  hasResult() {
    return this.getNumberOfRows() > 0;
  }

  isResultComplete() {
    return this.getBoolean('isResultComplete');
  }

  setResultComplete(v) {
    return this.setBoolean('isResultComplete', v);
  }

  getTurnover() {
    return this.getObject('turnover', Money);
  }

  setTurnover(v) {
    return this.setObject('turnover', v);
  }

  getNumberOfSystems() {
    return this.getInteger('nrOfSystems');
  }

  setNumberOfSystems(v) {
    return this.setInteger('nrOfSystems', v);
  }

  getRows() {
    return this.getObjects('rows', ResultRow);
  }

  getRow(index) {
    return this.getObject('rows', ResultRow, index);
  }

  getNumberOfRows() {
    return this.getNumberOf('rows');
  }

  addRow(data) {
    return this.addObject('rows', ResultRow, data);
  }

  getPayouts() {
    return this.getObjects('payouts', ResultPayout);
  }

  getPayout(index) {
    return this.getObject('payouts', ResultPayout, index);
  }

  getNumberOfPayouts() {
    return this.getNumberOf('payouts');
  }

  addPayout(data) {
    return this.addObject('payouts', ResultPayout, data);
  }

  getNumberOfOdds() {
    return this.getNumberOf('oddsResults');
  }

  getOdds(n) {
    return this.getObject('oddsResults', ResultOdds, n);
  }

  setOdds(v) {
    this.setObjects('oddsResults', v);
  }
}

class ResultRow extends BaseDataObject {
  getSystemsLeft() {
    return this.getInteger('systemsLeft');
  }

  setSystemsLeft(v) {
    return this.setInteger('systemsLeft', v);
  }

  getValue() {
    return this.getObject('value', Money);
  }

  setValue(v) {
    return this.setObject('value', v);
  }

  getWinners() {
    return this.getIntegerArray('winners');
  }

  setWinners(v) {
    return this.setIntegerArray('winners', v);
  }

  isWinner(index) {
    return this.getIntegerArray('winners').includes(index + 1);
  }

  isComplete() {
    return this.getWinners().length > 0;
  }
}

class ResultPayout extends BaseDataObject {
  getNumberOfCorrects() {
    return this.getInteger('nrOfCorrects');
  }

  setNumberOfCorrects(v) {
    return this.setInteger('nrOfCorrects', v);
  }

  getPrizeGroup() {
    return this.getString('prizeGroup');
  }

  setPrizeGroup(v) {
    return this.setString('prizeGroup', v);
  }

  getNumberOfSystems() {
    return this.getInteger('nrOfSystems');
  }

  setNumberOfSystems(v) {
    return this.setInteger('nrOfSystems', v);
  }

  getPayoutAmount() {
    return this.getObject('payOutAmount', Money);
  }

  setPayoutAmount(v) {
    return this.setObject('payOutAmount', v);
  }

  getTotalAmount() {
    return this.getObject('totalAmount', Money);
  }

  setTotalAmount(v) {
    return this.setObject('totalAmount', v);
  }
}
